import { createContext } from 'react'

import { IUserInfoDto } from '../api'

interface IUserInfoProviderState extends IUserInfoDto {}

const UserInfoProviderContext = createContext<IUserInfoProviderState>(null)

export { UserInfoProviderContext }
